import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { AsyncPipe } from '@angular/common';
import { environment } from '@environments/environment';
import { LoginService } from '@services/login.service';
import { NotificationService } from '@services/notification.service';
import { PreferencesService } from '@services/preferences.service';
import { Observable } from 'rxjs';
import { Notification } from '@models/notification.model';
import { LogService } from '@services/log.service';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    MatBadgeModule,
    RouterLink,
    AsyncPipe
  ],
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  #loginService = inject(LoginService);
  #notificationService = inject(NotificationService);
  #preferencesService = inject(PreferencesService);
  #logService = inject(LogService);

  name = environment.appName;
  logo = environment.logo;
  appUrl = environment.appUrl;
  showPoweredBy = environment.whiteLabel;
  userName = 'John Doe'; // Placeholder for user name
  isUserLoggedIn$: Observable<boolean>;
  notifications$: Observable<Notification[]>;
  unreadNotificationCount$: Observable<number>;

  constructor() {
    this.isUserLoggedIn$ = this.#loginService.isLoggedIn();
    this.notifications$ = this.#notificationService.getNewNotifications(); // Only show NEW notifications in header
    this.unreadNotificationCount$ = this.#notificationService.getUnreadCount();
    
    this.isUserLoggedIn$.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.userName = (this.#loginService.loginUser ? `${this.#loginService.loginUser.firstName} ${this.#loginService.loginUser.lastName}` : 'Test User');
      }
    });
  }

  get isStandaloneMode(): boolean {
    return this.#preferencesService.isStandalone();
  }

  onLogout(): void {
    // Placeholder for logout functionality
    console.log('Logout clicked');
    this.#loginService.logout();
    this.#logService.addUserActionLog('LOGOUT');
  }

  onNotificationClick(notification: Notification): void {
    // Mark notification as read and execute its action
    this.#notificationService.markAsRead(notification.id);
    notification.action();
  }

  onMarkAllNotificationsRead(): void {
    this.#notificationService.markAllAsRead();
  }

  onClearAllNotifications(): void {
    this.#notificationService.clearAllNotifications();
  }

  onRefreshNotifications(): void {
    this.#notificationService.refreshNotifications();
  }
}
